import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import username from 'flarum/common/helpers/username';
import WarningPreview from './WarningPreview';
export default class PostWarning extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "warning", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.warning = this.attrs.warning;
  }
  view() {
    return m("div", {
      className: "Post-warning"
    }, m("span", {
      className: "Post-warning-summary"
    }, m(Icon, {
      name: "fas fa-exclamation-circle"
    }), this.warning.strikes() ? app.translator.trans('fof-moderator-warnings.forum.post.warning', {
      strikes: this.warning.strikes() || 0,
      mod_username: username(this.warning.addedByUser())
    }) : app.translator.trans('fof-moderator-warnings.forum.post.warning_no_strikes', {
      mod_username: username(this.warning.addedByUser())
    })));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    const warning = this.warning;
    let timeout;
    const hidePreview = () => {
      this.$('.Post-warning-preview').removeClass('in').one('transitionend', function () {
        $(this).hide();
      });
    };
    const $preview = $('<ul class="Dropdown-menu Post-warning-preview fade"/>');
    this.$().append($preview);
    this.$().children().hover(function () {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        if (!$preview.hasClass('in') && $preview.is(':visible')) return;

        // When the user hovers their mouse over the list of people who have
        // replied to the post, render a list of reply previews into a
        // popup.
        m.render($preview[0], m("li", {
          "data-id": warning.id()
        }, m(WarningPreview, {
          warning: warning
        })));
        $preview.show();
        setTimeout(() => $preview.off('transitionend').addClass('in'));
      }, 200);
    }, function () {
      clearTimeout(timeout);
      timeout = setTimeout(hidePreview, 250);
    });

    // Whenever the user hovers their mouse over a particular name in the
    // list of repliers, highlight the corresponding post in the preview
    // popup.
    $('.Post-warning').find('.Post-warning-summary a').hover(function () {
      $('.Post-warning').find('[data-number="' + $(this).data('number') + '"]').addClass('active');
    }, function () {
      $('.Post-warning').find('[data-number]').removeClass('active');
    });
  }
}
flarum.reg.add('fof-moderator-warnings', 'forum/components/PostWarning', PostWarning);